<div class="col-sm-12 col-md-5 col-lg-4 pr-md-0"
    [ngClass]="showChatListForSmallScreen !== undefined ? (showChatListForSmallScreen === true ? 'd-block' : 'd-none') : ''">
    <div id="chat-list-card" class="card card-border chat-list-height">

        <div class="row px-4">
            <div class="col-xs-12 col-sm-12 my-3">
                <h4>
                    <strong>Service Requests</strong>
                    <span *ngIf="sRListGroupList && accessingFrom === 'page'"
                        class="text-danger count-badge position-absolute">
                        {{sRListGroupList.length}}
                    </span>
                </h4>
            </div>
        </div>

        <div class="row px-4">
            <div class="col-sm-12 col-xs-12 panel-group" id="accordion">
                <cdk-virtual-scroll-viewport itemSize="50" class="chat-list-scrollbarView">
                    <ng-container *cdkVirtualFor="let sr of sRListGroupList; let i = index">
                        <div [id]="sr.tripId" class="panel panel-default">
                            <div *ngIf="accessingFrom === 'page'" class="panel-heading p-0">
                                <a data-toggle="collapse" data-parent="#accordion" [href]="'#collapse' + i"
                                    (click)="sr.isAccordionOpen = !sr.isAccordionOpen">
                                    <div class="px-4 py-3">
                                        <div class="d-flex justify-content-between align-items-center">
                                            <div>
                                                <div class="py-2">
                                                    <h4 class="panel-title group-name-color">
                                                        {{sr.tripId}}
                                                    </h4>
                                                </div>
                                                <div class="d-flex flex-wrap">
                                                    <div>
                                                        <i class="fa fa-sm fa-circle" style="font-size: 0.7em;"></i>
                                                        <span class="ml-2 mr-3">{{sr.customerName}}</span>
                                                    </div>
                                                    <div>
                                                        <i class="fa fa-sm fa-circle" style="font-size: 0.7em;"></i>
                                                        <span class="ml-2 cursorPointer" id="serviceSubType{{i}}"
                                                            [title]="sr.srSubType.split(',').join(', ')">
                                                            {{sr.srType}}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="text-nowrap">
                                                <span *ngIf="totalUnreadMessageCount(sr.groupLists) > 0"
                                                    class="text-danger message-count-badge font-small">
                                                    {{ totalUnreadMessageCount(sr.groupLists) }}
                                                </span>
                                                <span class="ml-4">
                                                    <i
                                                        [ngClass]="sr.isAccordionOpen ? 'fa fa-chevron-up': 'fa fa-chevron-down'"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div [id]="'collapse' + i" class="panel-collapse collapse"
                                [ngClass]="accessingFrom === 'page' ? '' : 'in'">
                                <ul class="list-group cursorPointer">

                                    <ng-container *ngFor="let groupChat of sr.groupLists; let i = index">
                                        <li class="list-group-item group-content-color chat-box-height"
                                            (click)="groupChat.unreadMessageCount = 0; openMessagePage(sr, groupChat)">
                                            <div class="d-flex justify-content-between align-items-center mb-2">
                                                <div class="d-flex align-items-end">
                                                    <div class="group-name-container">
                                                        <h5 class="group-name-color my-0 overflow-ellipsis"
                                                            [title]="groupChat.groupName">
                                                            {{groupChat.groupName}}
                                                        </h5>
                                                    </div>
                                                    <div *ngIf="isShowChatTypeBadge" class="ml-2">
                                                        <span class="badge" [ngClass]="
                                                        {
                                                            'red': groupChat.serviceRequestGroupType === chatGroupType.internal,
                                                            'orange': groupChat.serviceRequestGroupType === chatGroupType.custom,
                                                            'blue': groupChat.serviceRequestGroupType === chatGroupType.vendor,
                                                            'green': groupChat.serviceRequestGroupType === chatGroupType.customer
                                                        }
                                                        ">
                                                            <span>{{groupChat.serviceRequestGroupType}}</span>
                                                        </span>
                                                    </div>
                                                </div>
                                                <div class="text-nowrap">
                                                    <span *ngIf="groupChat.unreadMessageCount > 0"
                                                        class="text-danger message-count-badge ml-4 font-small">
                                                        {{ groupChat.unreadMessageCount }}
                                                    </span>
                                                    <span class="ml-4">
                                                        <i class="fa fa-chevron-right text-danger"></i>
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="overflow-ellipsis mr-5">
                                                <span *ngIf="groupChat.lastMessageSenderId != defaultGUID"
                                                    class="sender-name">
                                                    <b>
                                                        {{ groupChat.lastMessageSenderId === user.memberId ? 'You:' :
                                                        groupChat.lastMessageSender + ':' }}
                                                    </b>
                                                </span>
                                                <mat-icon *ngIf="groupChat.lastAttachmentType" class="image-icon"
                                                    title="Image">
                                                    wallpaper
                                                </mat-icon>
                                                <span class="last-message" [title]="groupChat.lastMessage">
                                                    {{ groupChat.lastMessage }}
                                                </span>
                                            </div>
                                            <div class="message-time-stamp-container">
                                                <span>
                                                    <span
                                                        *ngIf="groupChat.lastMessageSentTime.toString() !== defaultTextMessageUTCDate"
                                                        class="message-timestamp font-small">
                                                        {{ groupChat.lastMessageSentTime | localDate: timeZone }}
                                                    </span>
                                                    <span
                                                        *ngIf="groupChat.lastMessageSentTime.toString() === defaultTextMessageUTCDate"
                                                        class="message-timestamp font-small">
                                                        {{ groupChat.groupCreatedOn | localDate: timeZone }}
                                                    </span>
                                                </span>
                                            </div>
                                        </li>
                                    </ng-container>

                                    <li *ngIf="isAddNewGroupVisible
                                    && sRListGroupList[0].serviceRequestStatus != serviceRequestStatusEnum.COMPLETED
                                    && sRListGroupList[0].serviceRequestStatus != serviceRequestStatusEnum.CANCELLED
                                    && sRListGroupList[0].serviceRequestStatus != serviceRequestStatusEnum.CANCELLED_WITH_ZERO_MOVEMENT
                                    && sRListGroupList[0].serviceRequestStatus != serviceRequestStatusEnum.CANCELLED_WITH_POSITIVE_MOVEMENT"
                                        class="list-group-item group-content-color px-0 py-0">
                                        <div class="chat-box-height d-flex align-items-center justify-content-center">
                                            <button class="header-btn background-inherit" id="create-new-group"
                                                (click)="openCreateNewGroupDialog(sr)">
                                                <i class="fa fa-plus fa-lg"></i>
                                                <span class="pl-3 font-medium">Add New Group</span>
                                            </button>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </ng-container>
                </cdk-virtual-scroll-viewport>
            </div>
        </div>

    </div>
</div>
